export default __webpack_public_path__ + "static/media/nicole-corner.523d1142.jpg";